import { useInfrastructureSectionContent } from './useInfrastructureSectionContent';
import { parseInfrastructureGlobalContent } from '../utils/infrastructureContent';

export const useInfrastructureGlobalContent = () =>
  useInfrastructureSectionContent(parseInfrastructureGlobalContent);
